// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DayPeriods } from './DayPeriods';
import { MainTypes } from './MainTypes';
import { SubTypes } from './SubTypes';
export class SessionPeriod {
    constructor(id, description, dayPeriod, begins, ends) {
        this.description = '';
        this.dayPeriod = DayPeriods.MAIN;
        this.mainType = MainTypes.MAIN_CONTINUOUS1;
        this.subType = SubTypes.CONTINUOUS;
        this.isIntraday = false;
        this.decreaseOnlyPositionCount = false;
        this.allowOptionsExerciseOnLastTradeDate = false;
        this.id = id;
        this.description = description;
        this.dayPeriod = dayPeriod;
        this.begins = begins;
        this.ends = ends;
    }
    GetBegin(dayOfWeek) {
        return this.begins[dayOfWeek];
    }
    GetEnd(dayOfWeek) {
        return this.ends[dayOfWeek];
    }
    IsMain() {
        return this.dayPeriod === DayPeriods.MAIN;
    }
    static IsMainType(type) {
        return (type === MainTypes.AUCTION_OPEN ||
            type === MainTypes.MAIN_CONTINUOUS1 ||
            type === MainTypes.IN_BETWEEN_CLEARING ||
            type === MainTypes.MAIN_CONTINUOUS2 ||
            type === MainTypes.AUCTION_CLOSE ||
            type === MainTypes.CLEARING);
    }
    isBeforeOrAfterMarket() {
        return this.dayPeriod === DayPeriods.BEFORE_MARKET || this.dayPeriod === DayPeriods.AFTER_MARKET;
    }
    toString() {
        const formatTimeUTC = (date) => {
            const hours = date.getUTCHours().toString().padStart(2, '0');
            const minutes = date.getUTCMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
        };
        const result = [];
        result.push('==SessionPeriod==');
        result.push(`Id: ${this.id};`);
        result.push(`DayPeriod: ${this.dayPeriod};`);
        result.push(`MainType: ${this.mainType};`);
        result.push(`Description: ${this.description};`);
        result.push('0 - Sunday; 1 - Monday; 2 - Tuesday; 3 - Wednesday; 4 - Thursday; 5 - Friday; 6 - Saturday;');
        for (let i = 0; i < this.begins.length; i++) {
            const dayOfWeek = i;
            const beginTime = this.begins[i];
            const endTime = this.ends[i];
            result.push(`${dayOfWeek} (${formatTimeUTC(beginTime)} - ${formatTimeUTC(endTime)});`);
        }
        return result.join('\n');
    }
}
